import { gql, useMutation } from '@apollo/client';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';

import { SignInAdministratorMutation } from '../../../generated/graphql';
import {
  ColumnTwo,
  ColumnTwoFooter,
  Form,
  HeadingBar,
  HeadingOne,
  HeadingThree,
  HeadingTwo,
  HeadingWrapper,
  Input,
  Label,
  LoginButton,
  ShowPassword,
} from './styles';

export const SecondColumn = (): JSX.Element => {
  const [showPassword, setShowPassword] = React.useState<boolean>(false);
  const [email, setEmail] = React.useState<string>('');
  const [password, setPassword] = React.useState<string>('');

  const navigate = useNavigate();

  // graphql query
  const SIGN_IN_ADMINISTRATOR = gql`
    mutation signInAdministrator($email: String!, $password: String!) {
      signInAdministrator(email: $email, password: $password) {
        token
      }
    }
  `;

  const [signInAdministrator, { data, loading }] =
    useMutation<SignInAdministratorMutation>(SIGN_IN_ADMINISTRATOR);

  React.useEffect(() => {
    const token = data?.signInAdministrator?.token;
    if (data && token) {
      localStorage.setItem('coe-admin-token', token);
      navigate('/admin/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const onSignInAdmin = async (e: React.MouseEvent<HTMLElement>): Promise<void> => {
    e.preventDefault();
    try {
      await signInAdministrator({ variables: { email, password } });
    } catch (err) {
      if (err?.message.includes('Failed to fetch')) {
        toast.error(`Network Error`);
        return;
      }
      toast.error(
        err?.message || `Incorrect credentials. Please try again or Contact CoE Exams Tech Support`,
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: 'text-white bg-red-500',
          progressClassName: 'bg-[#ffeeee]',
        },
      );
    }
  };

  return (
    <ColumnTwo>
      <HeadingWrapper>
        <HeadingOne>Sign in as</HeadingOne>
        <HeadingTwo>College of Engineering, KNUST</HeadingTwo>
        <HeadingThree style={{ wordSpacing: '6px' }}>Exams Officer</HeadingThree>
        <HeadingBar style={{ padding: '2.5px' }} />
      </HeadingWrapper>
      <Form>
        <Label>Email</Label>
        <Input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          type="email"
          required
          placeholder="Enter your email"
        />
        <Label>Password</Label>
        <Input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          type={showPassword ? 'text' : 'password'}
          placeholder="Enter your password"
        />
        <ShowPassword unselectable="on" onClick={() => setShowPassword(!showPassword)}>
          {!showPassword ? 'Show password' : 'Hide password'}
        </ShowPassword>
        <LoginButton onClick={onSignInAdmin}>
          {loading ? <BeatLoader color="#000f" size={20} /> : 'Log in'}
        </LoginButton>
      </Form>
      <ColumnTwoFooter>
        Contact{' '}
        <a
          target="_blank"
          href="https://mail.google.com/mail/u/0/?fs=1&to=examssupportcoe@gmail.com&tf=cm"
          rel="noreferrer"
        >
          <em>
            <b style={{ color: '#0050D4' }}>examssupportcoe@gmail.com</b>
          </em>{' '}
        </a>
        for any further assistance
      </ColumnTwoFooter>
    </ColumnTwo>
  );
};
